<template>
  <div :class="['layout-container']">
    <p class="layout-name text-truncate" :title="layout.name">{{ layout.name }}</p>
    <div class="grid-layout__container" :style="{ height: previewHeight }">
      <widget
        v-for="widget in items"
        :widget="widget"
        :key="widget.local_id"
        :style="{ ...gridItemStyles(widget) }"
        :isCard="isCard"
      />
    </div>
  </div>
</template>

<script>
import Widget from "./LayoutPreviewSlot.vue";
import useLayout from "@/composables/layouts";
import { onMounted, reactive, toRefs, computed, watch } from "@vue/composition-api";

export default {
  components: {
    Widget,
  },
  props: {
    layout: Object,
  },
  setup(props) {
    const { gridItemStyles, slotHeight } = useLayout(props.layout, 15);
    const state = reactive({
      items: [],
    });
    const isCard = computed(() => props.layout.is_card === 1 || props.layout.isCard === 1);

    // Preview cells are absolutely positioned (top/height in px), so they do not
    // stretch the container. Size it to the real grid height to avoid the cells
    // overflowing onto the next layout's name.
    const previewHeight = computed(() => {
      if (!state.items.length) return `${8 * slotHeight.value}px`;
      const rows = Math.max(
        ...state.items.map((w) => (Number(w.y) || 0) + (Number(w.h) || 0))
      );
      return `${(rows || 8) * slotHeight.value}px`;
    });

    // Función para actualizar items
    const updateItems = () => {
      state.items = props.layout.grid ? [...props.layout.grid] : [...props.layout.data];
    };

    // Cargar items inicialmente
    onMounted(() => updateItems());

    // Escuchar cambios en el layout para actualizar items reactivamente
    watch(() => props.layout, (newLayout) => {
      updateItems();
    }, { deep: true, immediate: true });

    return {
      ...toRefs(state),
      gridItemStyles,
      isCard,
      previewHeight,
    };
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  &.selected,
  &:hover {
    .app-grid {
      .slot-item {
        border: 1px solid #fff;
      }
    }
  }
}

</style>
